import type React from 'react';

/**
 * A section of a page with an optional side navigation.
 *
 * Must be used within `PageMain`.
 */
export function PageSection(props: { children: React.ReactNode }) {
    return <section className="flex w-full flex-col gap-4">{props.children}</section>;
}

export function PageSectionWithNav(props: { children: React.ReactNode }) {
    return <section className="flex w-full flex-col gap-10 lg:flex-row">{props.children}</section>;
}

/**
 * The section containing the side navigation of a page section.
 *
 * Style rules:
 * lg+ screen:
 * lg- screens: the section nav moves to a `row`
 * as the side nav should be replaced with an horizontal toolbar pickers.
 * sm screen: on very small screen the
 */
export function PageSectionNav(props: { children: React.ReactNode }) {
    return (
        <nav className="flex shrink-0 gap-4 max-lg:self-end max-xs:flex-col max-xs:items-end lg:flex-col">
            {props.children}
        </nav>
    );
}

export function PageSectionHeading(props: { children: React.ReactNode }) {
    return <h3 className="text-ui-heading-medium">{props.children}</h3>;
}
